import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-domicilios',
  templateUrl: './dlg-domicilios.component.html',
  styleUrls: ['./dlg-domicilios.component.css']
})
export class DlgDomiciliosComponent implements OnInit {

  titulo="";
  idDomicilio="";

  txtTipoDomicilio="";
  idTipoDomicilio="";
  nombreTipoDomicilio="";
  txtDomicilioCalle="";
  txtDomicilioNum="";
  txtDomicilioPiso="";
  txtDomicilioDepto="";

  txtProvincia="";
  idProvincia="";
  nombreProvincia="";

  nombreLocalidad="";
  txtLocalidad="";
  idLocalidad="";

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgDomiciliosComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena, idDomicilio: this.idDomicilio
      ,idTipoDomicilio: this.idTipoDomicilio
      ,nombreTipoDomicilio: this.nombreTipoDomicilio, txtDomicilioCalle: this.txtDomicilioCalle
      ,txtDomicilioNum: this.txtDomicilioNum, txtDomicilioPiso: this.txtDomicilioPiso
      ,txtDomicilioDepto: this.txtDomicilioDepto, idProvincia: this.idProvincia
      ,nombreProvincia: this.nombreProvincia, idLocalidad: this.idLocalidad
      ,nombreLocalidad: this.nombreLocalidad
    });
  }

  //#region tipo de domicilio
  buscarTipoDomicilio(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Tipos de domicilio:";
    dlgBusquedas.componentInstance.codBusqueda="TIPDOMICILIO";
    dlgBusquedas.componentInstance.txtBusc=this.txtTipoDomicilio;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idTipoDomicilio!=null){
          this.idTipoDomicilio=data.idTipoDomicilio;
          this.nombreTipoDomicilio=data.nombre;
        }
      }
    );
  }
  
  eliminarTipoDomicilio(){
    this.idTipoDomicilio="";
    this.nombreTipoDomicilio="";
  }
  //#endregion
  
  //#region provincia
  buscarProvincia(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Provincia:";
    dlgBusquedas.componentInstance.codBusqueda="PROVINCIA";
    dlgBusquedas.componentInstance.txtBusc=this.txtProvincia;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idProvincia!=null){
          this.idProvincia=data.idProvincia;
          this.nombreProvincia=data.nombre;
        }
      }
    );
  }

  eliminarProvincia(){
    this.idProvincia="";
    this.nombreProvincia="";
    this.idLocalidad="";
    this.nombreLocalidad="";
  }
  //#endregion

  //#region localidad
  buscarLocalidad(){
    if (this.idProvincia==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al buscar la localidad";
      dlgError.componentInstance.texto="Antes de buscar la localidad tiene que indicar la provicia";
      return;
    }
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Localidad:";
    dlgBusquedas.componentInstance.codBusqueda="LOCALIDAD";
    dlgBusquedas.componentInstance.txtBusc=this.txtLocalidad;
    dlgBusquedas.componentInstance.idGeneral=this.idProvincia;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idLocalidad!=null){
          this.idLocalidad=data.idLocalidad;
          this.nombreLocalidad=data.nombre;
        }
      }
    );
  }

  eliminarLocalidad(){
    this.idLocalidad="";
    this.nombreLocalidad="";
  }
  //#endregion

  almacenar(){
    if (this.idTipoDomicilio==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el domicilio";
      dlgError.componentInstance.texto="Le falto indicar el tipo de domicilio";
      return;
    }
    if (this.txtDomicilioCalle==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el domicilio";
      dlgError.componentInstance.texto="Le falto indicar la calle";
      return;
    }
    if (this.idProvincia==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el domicilio";
      dlgError.componentInstance.texto="Le falto indicar la provincia";
      return;
    }
    if (this.idLocalidad==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el domicilio";
      dlgError.componentInstance.texto="Le falto indicar la localidad";
      return;
    }
    this.cerrar('almaceno');
  }
}
